import * as React from 'react';
import { Box } from '@mui/material';
import { useEffect, useRef } from 'react';

export default function HsContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  const scrollableRef = useRef<null | HTMLDivElement>(null);
  const contentRef = useRef<null | HTMLDivElement>(null);
  const isMouseDown = useRef(false);

  useEffect(() => {
    const el = scrollableRef.current;
    const contentEl = contentRef.current;

    const wheelListener = (e: WheelEvent) => {
      const delta = e.deltaY / 2;

      if (el && contentEl) {
        const isScrollEdge =
          (el.scrollLeft === 0 && delta < 0) ||
          (delta > 0 &&
            el.scrollLeft + el.offsetWidth === contentEl.offsetWidth);

        el.scrollLeft += delta;

        if (isScrollEdge) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
      }
    };
    const mouseDownListener = (e: MouseEvent) => {
      isMouseDown.current = true;
      if (el) {
        el.style.cursor = 'grabbing';
      }
    };
    const mouseUpListener = (e: MouseEvent) => {
      isMouseDown.current = false;
      if (el) {
        el.style.cursor = 'grab';
      }

      if (contentRef.current) {
        contentRef.current.style.pointerEvents = 'all';
      }
    };
    const mouseMoveListener = (e: MouseEvent) => {
      if (isMouseDown.current && el) {
        el.scrollLeft -= e.movementX;

        if (contentRef.current) {
          contentRef.current.style.pointerEvents = 'none';
        }
      }
    };

    if (el) {
      el.addEventListener('wheel', wheelListener, {
        passive: false,
      });
      el.addEventListener('mousedown', mouseDownListener);
      document.addEventListener('mouseup', mouseUpListener);
      el.addEventListener('mousemove', mouseMoveListener);
    }
    return () => {
      if (el) {
        el.removeEventListener('wheel', wheelListener);
        el.removeEventListener('mousedown', mouseDownListener);
        document.removeEventListener('mouseup', mouseUpListener);
        el.removeEventListener('mousemove', mouseMoveListener);
      }
    };
  }, []);

  return (
    <Box
      ref={scrollableRef}
      className="noselect noscroll"
      sx={{
        overflowX: 'auto',
        width: 1,
        cursor: 'grab',
      }}
    >
      <Box
        ref={contentRef}
        sx={{
          width: 'max-content',
          minWidth: '100%',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
